module.exports = __webpack_public_path__ + "img/tp-toggle-off.f6c6622e.svg";